<template>
  <div>
    <AccountDetail
      v-if="isDetail"
      :account="selectedAccount"
      @returnToAcc="returnToAcc"
      @editAccount="editAccount"
    />
    <div class="Account container-fluid pt-0" v-else>
      <div class="row row-margin-bottom gx-0 gy-0">
        <div class="header-dash col-lg-10">
          <h1>Minhas contas</h1>
        </div>
      </div>
      <div class="row justify-content-between row-margin-bottom gy-0 mx-3">
        <button
          class="btn-default-transparent no-width col-auto px-3"
          @click="openNewAccountModal"
        >
          <i class="fa-solid fa-circle-plus" />
          <span> Nova conta</span>
        </button>
        <OpenFinanceButton />
      </div>

      <div class="row gap-3 gx-0 gy-0">
        <div class="col-lg box">
          <h3 class="custom-box-title">Conta corrente/poupança</h3>
          <div v-for="(account, index) in accounts_defaults" :key="index">
            <AccountBox
              :account="account"
              @accDetail="accDetail"
              @editAccount="editAccount"
            />
          </div>
        </div>

        <div class="col-lg box">
          <h3 class="custom-box-title">Cartão de crédito</h3>
          <div v-for="(account, index) in accounts_card" :key="index">
            <AccountBox
              :account="account"
              @accDetail="accDetail"
              @editAccount="editAccount"
            />
          </div>
        </div>
        <div class="col-lg box">
          <h3 class="custom-box-title">Conta de investimento</h3>
          <div v-for="(account, index) in accounts_investment" :key="index">
            <AccountBox
              :account="account"
              @accDetail="accDetail"
              @editAccount="editAccount"
            />
          </div>
        </div>
      </div>
    </div>

    <Modal :title="modalTitle" :is-open="isModalOpen" @close="closeModal">
      <FormAccount v-if="!isEditing" @close="closeModal" />
      <FormEditAccount
        v-if="isEditing"
        :account="accToedit"
        @close="closeModal"
        @returnToAcc="returnToAcc"
      />
    </Modal>
  </div>
</template>

<script>
import AccountBox from "../bank_account/AccountBox.vue";
import Modal from "../shared/Modal.vue";
import AccountDetail from "../bank_account/AccountDetail.vue";
import FormAccount from "../bank_account/FormAccount.vue";
import { useAppStore } from "@/store/store.js";
import { useOpenFinanceStore } from "@/store/open_finance/store.js";
import FormEditAccount from "../bank_account/FormEditAccount.vue";
import OpenFinanceButton from "../open_finance/OpenFinanceButton.vue";
import { useConfirm } from "primevue/useconfirm";

export default {
  components: {
    AccountBox,
    Modal,
    FormAccount,
    AccountDetail,
    FormEditAccount,
    OpenFinanceButton
  },
  data() {
    return {
      modalType: "account",
      plan: "",
      isEditing: false,
      isDetail: false,
      isModalOpen: false,
      accToedit: {},
      title: "Nova Conta",
    };
  },
  setup() {
    return { confirm: useConfirm() };
  },
  mounted() {
    useOpenFinanceStore().getSyncStatus();
  },
  computed: {
    accounts_card() {
      if (!this.accounts) {
        return [];
      }
      // Filtrar apenas os objetos que têm account_type igual a 1
      return this.accounts.filter((item) => item.id_account_type == "4");
    },
    modalTitle() {
      if (!this.isEditing) {
        return this.title;
      } else {
        return this.accToedit.id_account_type === 4
          ? "Editar Cartão"
          : "Editar Conta";
      }
    },
    accounts_investment() {
      if (!this.accounts) {
        return [];
      }
      // Filtrar apenas os objetos que têm id_account_type igual a 3
      return this.accounts.filter((item) => item.id_account_type == "3");
    },
    accounts_defaults() {
      if (!this.accounts) {
        return [];
      }
      // Filtrar apenas os objetos que têm id_account_type igual a 1 ou 2
      return this.accounts.filter(
        (item) => item.id_account_type == "1" || item.id_account_type == "2"
      );
    },
    accounts() {
      const store = useAppStore();
      const accounts = store.accountsResponse;
      return accounts;
    },
  },
  methods: {
    editAccount(value) {
      this.accToedit = value;
      this.isEditing = true;
      this.isModalOpen = true;
    },
    returnToAcc() {
      this.isDetail = false;
    },
    accDetail(acc) {
      this.isDetail = true;
      this.selectedAccount = acc;
    },
    closeModal() {
      this.isModalOpen = false;
      this.isEditing = false;
    },
    openNewAccountModal() {
      this.isModalOpen = true;
      this.title = "Nova conta";
    },
  },
};
</script>

<style lang="scss" scoped>
.Account {
  padding: 15px;
  color: white;
}
.custom-box-title {
  margin-left: 1rem;
  margin-bottom: 1rem;
  text-align: center;
  font-weight: bold;
}
</style>
